import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseResponseDto, CreateUserRequest } from '@aoe/client';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UserService extends ApiService {

    private readonly baseUrlAuth = `${environment.authUrl}${environment.authPort ? ':' + environment.authPort : ''}`;

    createUser(userData: CreateUserRequest): Observable<BaseResponseDto<string>> {
        return this.http.post<BaseResponseDto<string>>(`${this.baseUrlAuth}/user`, userData);
    }
} 
